(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('MassivePropertiesController', MassivePropertiesController);

    MassivePropertiesController.$inject = ['$state', 'paginationConstants', 'ListObjByObjTypeAndFleet', 'AlertService', 'TabFleets', 'ListObjAndObjType', '$uibModal'];

    function MassivePropertiesController($state, paginationConstants, ListObjByObjTypeAndFleet, AlertService, TabFleets, ListObjAndObjType, $uibModal) {
        var vm = this;
        vm.init = init;
        vm.selectObjectType = selectObjectType;
        vm.toggleSelection = toggleSelection;
        vm.chkUnChkAll = chkUnChkAll;
        vm.selectedFleet = selectedFleet;
        vm.checkOverwrittenProperties = checkOverwrittenProperties;
        vm.allChecked = false;
        vm.tabObjectTypes = [];
        vm.fleets = [];
        vm.fleet = null;
        vm.currentPage = 1;
        vm.itemsPerPageChosen = paginationConstants.itemsPerPage;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;

        function initializeVariable() {
            vm.tabObjects = [];
            vm.objectChecked = {};
            vm.selectionValue = [];
            vm.objectWithOldProps = {};
            vm.objType = {};
        }

        function init() {
            initializeVariable();
            TabFleets.query({}, function (data) {
                vm.fleets = data;
            }, onError);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function selectObjectType(item) {
            ListObjByObjTypeAndFleet.filtered({
                typeId: item.id,
                fleetId: vm.fleet.id,
                props: true
            }, onSuccess, onError);

            function onSuccess(data) {
                vm.tabObjects = data;
                vm.tabObjects.forEach(function (o) {
                    if (o.hasOverrideProperties === true)
                        vm.objectWithOldProps[o.objectUniqueCode] = true;
                });
            }
        }

        function selectedFleet(fleet) {
            ListObjAndObjType.query({
                id: fleet.id
            }, function (data) {
                initializeVariable();
                vm.tabObjectTypes = data.tabObjectTypesList;
                vm.fleet = fleet;
            }, onError);

        }

        function toggleSelection(object, index, all) {
            var isCheck = vm.objectChecked[index];
            if (isCheck == undefined || isCheck == null || isCheck === false) {
                vm.selectionValue.push(object.objectUniqueCode);
                vm.objectChecked[index] = true;
            }
            else if (!all) {
                vm.selectionValue.splice(vm.selectionValue.indexOf(object.objectUniqueCode), 1);
                delete vm.objectChecked[index];
            }

        }

        function chkUnChkAll() {
            vm.allChecked = !vm.allChecked;
            vm.tabObjects.forEach(function (obj, i, arr) {
                toggleSelection(obj, i, vm.allChecked);
            });
        }

        function checkOverwrittenProperties() {
            var warningObject = [];
            vm.selectionValue.forEach(function (sel) {
                if (vm.objectWithOldProps[sel]) {
                    warningObject.push(sel);
                }
            });
            if (warningObject.length > 0) {
                $uibModal.open({
                    templateUrl: 'app/entities/tab-objects/tab-objectstype-properties-dialog.html',
                    controller: 'TabObjectsTypesPropertiesDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        warnings: [function () {
                            return warningObject;
                        }]
                    }
                }).result.then(function () {
                    $state.go("massive-properties.update", {id: vm.objType.id, objects: vm.selectionValue});
                });
            } else {
                $state.go("massive-properties.update", {id: vm.objType.id, objects: vm.selectionValue});
            }
        }

        vm.init();

    }
})();
